import { Button, Form, Input, message } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShopOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

const { Title, Text } = Typography;

/** Key xác thực nhân viên cơ sở 2 (tách biệt với admin) */
export const BRANCH2_AUTH_KEY = 'isBranch2Staff8Am';
export const BRANCH2_LOGIN_TIME_KEY = 'branch2LoginTime8Am';

/**
 * Thông tin đăng nhập nhân viên cơ sở 2.
 * Chỉ có quyền nhập hóa đơn, không có quyền admin.
 */
const BRANCH2_CREDENTIALS = {
  username: 'nhanvien.cs2',
  password: 'cs2@8am2026',
};

const Branch2LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const onFinish = (values: { username: string; password: string }) => {
    if (
      values.username === BRANCH2_CREDENTIALS.username &&
      values.password === BRANCH2_CREDENTIALS.password
    ) {
      localStorage.setItem(BRANCH2_AUTH_KEY, 'true');
      localStorage.setItem(BRANCH2_LOGIN_TIME_KEY, Date.now().toString());
      navigate('/branch2-entry');
    } else {
      message.error('Sai tên đăng nhập hoặc mật khẩu!');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 16,
      }}
    >
      {/* Decorative background blobs */}
      <div
        style={{
          position: 'fixed',
          top: '10%',
          left: '5%',
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(59,130,246,0.15) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: '10%',
          right: '5%',
          width: 250,
          height: 250,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: 'rgba(255,255,255,0.05)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: 20,
          padding: '40px 36px',
          boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
        }}
      >
        {/* Logo & Title */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: 18,
              background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
              boxShadow: '0 8px 20px rgba(59,130,246,0.4)',
            }}
          >
            <ShopOutlined style={{ fontSize: 32, color: '#fff' }} />
          </div>
          <Title level={3} style={{ color: '#fff', margin: 0 }}>
            8AM Coffee
          </Title>
          <Text
            style={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: 14,
              display: 'block',
              marginTop: 4,
            }}
          >
            Nhập hóa đơn – Cơ sở 2
          </Text>
        </div>

        <Form name="branch2-login" onFinish={onFinish} layout="vertical">
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập!' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: 'rgba(255,255,255,0.3)' }} />}
              placeholder="Tên đăng nhập"
              size="large"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: 10,
                color: '#fff',
                height: 48,
              }}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(255,255,255,0.3)' }} />}
              placeholder="Mật khẩu"
              size="large"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: 10,
                color: '#fff',
                height: 48,
              }}
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              style={{
                background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                border: 'none',
                borderRadius: 10,
                height: 48,
                fontWeight: 600,
                fontSize: 15,
                boxShadow: '0 4px 15px rgba(59,130,246,0.3)',
              }}
            >
              Đăng nhập
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Text style={{ color: 'rgba(255,255,255,0.3)', fontSize: 12 }}>
            Tài khoản dành riêng cho nhân viên cơ sở 2
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Branch2LoginPage;
